var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.702,
    height: 55.664,
    viewBox: "0 0 61.702 55.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.286 -7.42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.274,63.077c-2.262,0-4.525.006-6.787,0-3.928-.013-5.248-2.233-3.335-5.628Q23.419,37.439,34.7,17.438c1.473-2.612,2.921-5.238,4.433-7.827,1.7-2.914,4.448-2.922,6.109-.021,2.589,4.519,5.117,9.073,7.721,13.583a3.9,3.9,0,0,1-.01,4.3q-9.96,16.846-19.873,33.72a3.59,3.59,0,0,1-3.388,1.888c-2.473-.025-4.946-.007-7.419,0Z",
    transform: "translate(0)",
    fill: "#504c4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.835,133.859c-2.947,0-5.894.028-8.841-.008-3.088-.037-4.5-2.346-3.017-5.046q4.365-7.957,8.871-15.837c1.612-2.817,4.451-2.782,6.063.033q4.433,7.739,8.8,15.517c1.692,3.017.3,5.318-3.189,5.34-2.894.018-5.789,0-8.683,0Z",
    transform: "translate(-79.439 -70.785)",
    fill: "#504c4c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.bdc30e724c133703d59ee6fad792ed86.svg";
export { ForwardRef as ReactComponent };